module.exports = __webpack_public_path__ + "static/media/wings design.68d182c1.png";